import { AeoPromptTopicSchema } from "@redotech/redo-model/aeo/prompt";
import * as z from "zod/v4";

export const AeoPromptSchema = z.object({
  id: z.bigint(),
  prompt: z.string(),
  branded: z.boolean(),
  topics: z.array(AeoPromptTopicSchema),
  createdAt: z.string(),
  deletedAt: z.string().nullable(),
});
export type AeoPrompt = z.infer<typeof AeoPromptSchema>;
